"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _StagedObject = _interopRequireDefault(require("redux-less/StagedObject"));

var _PropertyTypes = _interopRequireDefault(require("redux-less/constants/PropertyTypes"));

var _entitiesSelectors = require("settings-ui-modules/marketing/modules/collected-forms/selectors/entitiesSelectors");

var _stagedSelectors = require("settings-ui-modules/marketing/modules/collected-forms/selectors/stagedSelectors");

var _constants = require("settings-ui-sdk/MarketingFreeSettings/constants");

var properties = [_constants.FORM_CAPTURE_ENABLED, {
  key: _constants.SCRAPED_FORM_NOTIFICATION_EMAIL_LIST,
  type: _PropertyTypes.default.SIMPLE,
  initialValue: (0, _immutable.List)()
}];

var _default = new _StagedObject.default({
  domainSelector: _entitiesSelectors.getMarketingFreeSettings,
  stagedSelector: _stagedSelectors.getUpdateMarketingFreeSettings,
  namespace: 'collectedForms',
  objectType: _constants.MARKETING_FREE_SETTINGS,
  properties: properties
});

exports.default = _default;
module.exports = exports.default;